import { render } from "./ui-uploadfilebox2.vue?vue&type=template&id=748c2175"
import script from "./ui-uploadfilebox2.vue?vue&type=script&lang=js"
export * from "./ui-uploadfilebox2.vue?vue&type=script&lang=js"

import exportComponent from "/home/source/apps.macrofox.fr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__